import type { StaticImageData } from 'next/image';
import ENABLE_PUSH from '@/public/assets/image/gamification/missions/welcome-missions/enable-push@3x.webp';
import GET_OFFERS from '@/public/assets/image/gamification/missions/welcome-missions/get-offers@3x.webp';
import GET_THE_APP from '@/public/assets/image/gamification/missions/welcome-missions/get-the-app@3x.webp';

export type WelcomeMissionKind = 'get-the-app' | 'get-offers' | 'enable-push';

export const welcomeMissionOrder: WelcomeMissionKind[] = ['get-the-app', 'get-offers', 'enable-push'];

export const welcomeMissionImages: Record<WelcomeMissionKind, StaticImageData> = {
  'get-the-app': GET_THE_APP,
  'get-offers': GET_OFFERS,
  'enable-push': ENABLE_PUSH,
};
